import React from 'react';
import { AlertTriangle, Info, AlertCircle, Trash2 } from 'lucide-react';
import { CustomModal, CustomButton } from '../../atoms';
import './ConfirmationModal.css';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    variant?: 'danger' | 'warning' | 'info';
    isLoading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    variant = 'danger',
    isLoading = false
}) => {
    const getIcon = () => {
        switch (variant) {
            case 'danger':
                return <Trash2 size={32} />;
            case 'warning':
                return <AlertTriangle size={32} />;
            case 'info':
                return <Info size={32} />;
            default:
                return <AlertCircle size={32} />;
        }
    };

    const footer = (
        <div className="confirmation-modal-actions">
            <CustomButton
                variant="outline"
                color="secondary"
                onClick={onClose}
                disabled={isLoading}
            >
                {cancelLabel}
            </CustomButton>
            <CustomButton
                variant="filled"
                color={variant === 'danger' ? 'danger' : (variant === 'warning' ? 'warning' : 'primary')}
                onClick={onConfirm}
                loading={isLoading}
            >
                {confirmLabel}
            </CustomButton>
        </div>
    );

    return (
        <CustomModal
            isOpen={isOpen}
            onClose={onClose}
            size="small"
            showCloseButton={!isLoading}
            closeOnOverlayClick={!isLoading}
            className="confirmation-modal-wrapper"
        >
            <div className="confirmation-modal-content">
                <div className={`confirmation-modal-icon confirmation-modal-icon--${variant}`}>
                    {getIcon()}
                </div>
                <h3 className="confirmation-modal-title">{title}</h3>
                <p className="confirmation-modal-message">{message}</p>
                {footer}
            </div>
        </CustomModal>
    );
};
